import styles from './M_SelectPicker.module.css';
import A_ToggleButton from '@/components/A_Atoms/A_ToggleButton/A_ToggleButton';
import cn from 'classnames';

interface M_SelectPickerProps {
  options: string[];
  selectedOption: string;
  onSelect: (option: string) => void;
  background?: 'gray' | 'white';
}

export default function M_SelectPicker({
  options,
  selectedOption,
  onSelect,
  background = 'gray',
}: M_SelectPickerProps) {
  return (
    <div className={cn(styles.wrapper, styles[`background-${background}`])}>
      {options.map(option => (
        <A_ToggleButton
          key={option}
          isActive={option === selectedOption}
          onClick={() => onSelect(option)}
          title={option}
          bgColor={background}
        />
      ))}
    </div>
  );
}
